import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brXs = createBreakpoint('xs');
const brS = createBreakpoint('s');

export const mainCls = 'csa-login-container';

export default {
  [mainCls]: {
    padding: '0 8px 8px',
    [brXs]: {
      padding: '0 16px 16px',
    },
    [brS]: {
      margin: 0,
      paddingRight: 24,
      paddingLeft: 24,
    },
    minHeight: '100%',
    '&.force-height': {
      height: '100%',
    },
  },
};